import React, { useState, useEffect, useContext } from 'react';
import { intlFormat } from 'date-fns';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useDataHelper } from 'utils/dataHelper';

import translations from 'utils/translations';

import { breakoutRoomModel } from 'entities/breakoutRoomModel';
import { breakoutRoomInviteModel } from 'entities/breakoutRoomInviteModel';

import { SdmSpacer, SdmTypography } from 'components';

import PageHeader from '../components/PageHeader';
import BrCardsContainer from '../components/BrCardsContainer';

import { LoaderContext } from 'context/LoaderContextProvider';

import Grid from '@material-ui/core/Grid';

const AdminArea = ({ user }) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.personalArea(intl).adminPage;
  const dataHelper = useDataHelper();
  const history = useHistory();

  const { isLoaderActive, setLoaderActive } = useContext(LoaderContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);

  // States
  const [fetchedBr, setFetchedBr] = useState();
  const [totalCount, setTotalCount] = useState(0);

  // Effects
  useEffect(() => {
    if (user) {
      showLoader();
      fetchBr();
    }
  }, [user]);

  // Functions

  const fetchBr = async () => {
    let parsedBrByGroups = [];
    const state = history.location.state;
    if (state?.fetchedBreakouts) {
      parsedBrByGroups = state.fetchedBreakouts;
      history.replace(history.location.pathname, null);
    } else {
      const myBreakoutRooms =
        await breakoutRoomModel.gql.listAdminBreakoutRooms();
      setTotalCount(
        myBreakoutRooms?.items?.filter((br) => !!br.start && !!br.end)?.length
      );
      dataHelper
        .orderBreakoutRooms(myBreakoutRooms?.items)
        .filter((br) => !!br.start && !!br.end)
        .map((br) => {
          const parsedBr = {
            ...br,
            invitations: br.invitations.items.filter(
              (i) => i.status === breakoutRoomInviteModel.enums.status.ACCEPTED
            ).length,
          };
          const date = dataHelper.capitalizeFirst(
            intlFormat(
              new Date(br.date),
              {
                year: 'numeric',
                month: 'long',
              },
              {
                locale: dataHelper.getLangCode(intl.locale),
              }
            )
          );
          if (!Object.keys(parsedBrByGroups).includes(date)) {
            parsedBrByGroups[date] = [parsedBr];
          } else {
            parsedBrByGroups[date].push(parsedBr);
          }
        });
    }
    setFetchedBr(parsedBrByGroups);
    hideLoader();
  };

  return (
    <Grid container>
      <div style={{ width: '100%' }}>
        <PageHeader i18n={i18n} isBrandPage={false} />
        <div style={{ backgroundColor: fetchedBr ? '#f3f3f3' : 'white' }}>
          <div style={{ width: '80%', margin: '0 auto', maxWidth: 1250 }}>
            <SdmSpacer height={30} />
            {!isLoaderActive && fetchedBr ? (
              <>
                <div style={{ width: '100%' }}>
                  <SdmTypography
                    variant={'h2'}
                    style={{ marginRight: 0 }}
                    textAlign={'center'}
                  >
                    {i18n.numberBr}: {totalCount}
                  </SdmTypography>
                </div>
                {Object.keys(fetchedBr).length > 0 ? (
                  Object.keys(fetchedBr).map((key, idx) => {
                    const orderedBr = dataHelper.orderBreakoutRooms(
                      fetchedBr[key]
                    );
                    return (
                      <BrCardsContainer
                        key={idx}
                        date={key}
                        items={orderedBr}
                        isAdmin
                      />
                    );
                  })
                ) : (
                  <SdmTypography variant={'h2'} textAlign={'center'}>
                    {i18n.noBrBrandAvailable}
                  </SdmTypography>
                )}
              </>
            ) : null}
          </div>
          <SdmSpacer height={30} />
        </div>
      </div>
    </Grid>
  );
};

export default AdminArea;
